/* eslint-disable no-shadow */
/* eslint-disable max-len */
import React, { memo } from 'react'
import Button from '@material-ui/core/Button'

import {
	primaryButton,
	universalForm,
	noBackgroundButton,
	outlinedButton,
	squareButton,
	squareButtonOutlined,
	secondaryButton,
	loadMoreButton,
	neonGlow,
} from 'root/src/client/web/componentTypes'
import TooltipWraper from 'root/src/client/web/base/TooltipWraper'

import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import styles from './buttonStyle'

const Wrapper = ({ children, tooltipText }) => {
	if (tooltipText) {
		return 	(
			<TooltipWraper
				tooltipText={tooltipText}
			>{children}
			</TooltipWraper>
		)
	}
	return children
}

export const ButtonUnstyled = memo(({
	onClick, disabled, children, style, isSmallButton,
	buttonType, unstyled, className, formType, isButtonTest,
	tooltipText, error, classes, type,
}) => (
	<Wrapper tooltipText={tooltipText}>
		<Button
			type={type}
			className={classNames(
				style,
				({ [classes.button]: buttonType !== neonGlow }),
				{ [classes.unstyled]: unstyled },
				({ [classes.primaryButton]: buttonType === primaryButton || formType === universalForm }),
				({ [classes.noBackgroundButton]: buttonType === noBackgroundButton }),
				({ [classes.secondaryButton]: buttonType === secondaryButton }),
				({ [classes.smallButton]: isSmallButton }),
				({ [classes.buttonTest]: isButtonTest }),
				({ [classes.loadMoreButton]: buttonType === loadMoreButton }),
				({ [classes.outlinedButton]: buttonType === outlinedButton }),
				({ [classes.squareButton]: buttonType === squareButton || buttonType === squareButtonOutlined }),
				({ [classes.outlined]: buttonType === squareButtonOutlined }),
				({ [classes.neonGlow]: buttonType === neonGlow }),
				({ [classes.buttonDisabled]: disabled }),
				{ [classes.error]: error },
				className,
			)}
			onClick={(e) => {
				if (e?.preventDefault && onClick) {
					e.preventDefault()
				}
				if (onClick) {
					return onClick(e)
				}
				return undefined
			}}
			disabled={disabled}
			disableRipple
		>
			{children}
		</Button>
	</Wrapper>
))

export default withStyles(styles, { name: 'MsuiButtonBase' })(ButtonUnstyled)
